export default {
  MAIL_URL: 'https://netsurf.bg/nodejs',
  // MAIL_URL: 'http://localhost:5634',
}